module.exports = "/_next/static/images/row2-4-2x-5faef879885f44f55bc22dd0c43d13ce.png";